import config from '@config';
import merge from 'lodash/merge';

const fontFamily = 'FedraSansStd-medium';

const commonLangStyle = ({ lang, ...props }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const styleObj = {
    smHeading: {
      fontSize: { base: '1.5rem', md: '2rem' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      lineHeight: '38px',
      color: '#fff',
      fontWeight: 500,
    },
    mdHeading: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontSize: { md: '48px', base: '40px' },
      lineHeight: { base: '48px', md: '40px' },
      letterSpacing: '1px',
      color: '#fff',
      fontWeight: 500,
    },
    lgHeading: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontSize: { md: '72px', base: '64px' },
      lineHeight: { base: '60px', md: '65px' },
      color: '#EC1C2D',
      fontStyle: 'italic',
      fontWeight: 500,
    },
    benefitText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { md: '20px', base: '14px' },
      lineHeight: { md: '20px', base: '14px' },
      fontStyle: 'normal',
      fontWeight: 500,
    },
    cardHeading: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { md: '84px', base: '48px' },
      lineHeight: { md: '92px', base: '52px' },
      fontStyle: 'normal',
      fontWeight: 500,
    },
    cardHeadingSpan: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { md: '64px', base: '36px' },
      lineHeight: { md: '92px', base: '52px' },
      fontStyle: 'normal',
      fontWeight: 500,
    },
    cardDesc: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { md: '20px', base: '14px' },
      lineHeight: { md: '23px', base: '16px' },
      fontStyle: 'normal',
    },
    cardText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { md: '24px', base: '16px' },
      lineHeight: { md: '28px', base: '18px' },
      fontStyle: 'normal',
      letterSpacing: '-0.24px',
      fontWeight: 500,
    },
    //StudiesDone
    numText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '5.25rem', md: '110px' },
      lineHeight: { bae: '117px', md: '154px' },
      fontStyle: 'normal',
      letterSpacing: '-2.2px',
      fontWeight: 500,
      color: '#FFF',
    },
    descText: {
        fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
        fontSize: { base: '18px', md: '18px' },
        lineHeight: { bae: '120%', md: '120%' },
        fontStyle: 'normal',
        fontWeight: 500,
        color: '#FFFFFFB2',
      },
    stuText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '3rem', md: '4rem' },
      lineHeight: { base: '44px', md: '57px' },
      fontStyle: 'normal',
      letterSpacing: '-1.28px',
      fontWeight: 500,
      color: '#F01E1F',
    },
    byRText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '20px', md: '2rem' },
      lineHeight: { base: '22px', md: '44px' },
      fontStyle: 'normal',
      letterSpacing: '-0.24px',
      fontWeight: 500,
      color: '#FFF',
    },
    worText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontSize: { base: '36px', md: '56px' },
      lineHeight: { base: '40px', md: '50px' },
      fontStyle: 'italic',
      letterSpacing: '-0.24px',
      fontWeight: 500,
      color: '#FFF',
    },
    havText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '20px', md: '2rem' },
      lineHeight: { base: '22px', md: '55px' },
      letterSpacing: '-1.12px',
      fontWeight: 500,
      fontStyle: 'normal',
      color: '#FFF',
    },
    medText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '2rem', md: '3rem' },
      fontStyle: 'normal',
      lineHeight: { base: '38px', md: '55px' },
      letterSpacing: '-0.24px',
      fontWeight: 500,
      color: '#FFF',
    },
  };

  const finalObj = merge(styleObj, { ...props });
  return finalObj;
};

const ProvenBySt = {
  en: commonLangStyle({ lang: 'en' }),
  bn: commonLangStyle({ lang: 'bn' }),
  hi: commonLangStyle({
    lang: 'hi',
  }),
  te: commonLangStyle({ lang: 'te' }),
  kn: commonLangStyle({ lang: 'kn' }),
  gu: commonLangStyle({ lang: 'gu' }),
  mr: commonLangStyle({ lang: 'mr' }),
  ml: commonLangStyle({ lang: 'ml' }),
  'zh-tw': commonLangStyle({ lang: 'zh-tw' }),
  zh: commonLangStyle({ lang: 'zh' }),
  it: commonLangStyle({ lang: 'it' }),
  fr: commonLangStyle({ lang: 'fr' }),
  de: commonLangStyle({ lang: 'de' }),
  es: commonLangStyle({
    lang: 'es',
    stuText: {
      ...commonLangStyle({ lang: 'ru' }).stuText,
      wordBreak: 'break-all',
      fontSize: { base: '2rem', md: '2rem' },
    },
  }),
  ru: commonLangStyle({
    lang: 'ru',
    stuText: {
      ...commonLangStyle({ lang: 'ru' }).stuText,
      wordBreak: 'break-all',
      fontSize: { base: '2rem', md: '2rem' },
    },
  }),
  ta: commonLangStyle({
    lang: 'ta',
    smHeading: {
      ...commonLangStyle({ lang: 'ta' }).smHeading,
      fontSize: { md: '2rem', base: '1.5rem' },
      lineHeight: { md: '52px', base: '26px' },
    },
    mdHeading: {
      ...commonLangStyle({ lang: 'ta' }).mdHeading,
      fontSize: { md: '3rem', base: '2rem' },
      lineHeight: { md: '1.1em', base: '35px' },
    },
    lgHeading: {
      ...commonLangStyle({ lang: 'ta' }).lgHeading,
      fontSize: { md: '72px', base: '2rem' },
      lineHeight: { md: '1.2em', base: '35px' },
    },
    numText: {
      ...commonLangStyle({ lang: 'ta' }).numText,
      wordBreak: 'break-all',
    },
    stuText: {
      ...commonLangStyle({ lang: 'ta' }).stuText,
      wordBreak: 'break-all',
      fontSize: { base: '2rem', md: '2rem' },
    },
    byRText: {
      ...commonLangStyle({ lang: 'ta' }).byRText,
      wordBreak: 'break-all',
    },
    worText: {
      ...commonLangStyle({ lang: 'ta' }).worText,
      wordBreak: 'break-all',
    },
    havText: {
      ...commonLangStyle({ lang: 'ta' }).havText,
      wordBreak: 'break-all',
    },
    medText: {
      ...commonLangStyle({ lang: 'ta' }).medText,
      wordBreak: 'break-all',
    },
  }),
  cn: commonLangStyle({ lang: 'cn' }),
  ar: commonLangStyle({
    lang: 'ar',
  }),
  id: commonLangStyle({ lang: 'id' }),
};
export default ProvenBySt;
